import React from 'react';

import { MimeType } from '@aline/common';
import { FolderOpen } from 'lucide-react';

interface FileBadge {
  background: string;
  color: string;
  label: string;
}

const DOCUMENT_BADGE: FileBadge = { background: '#EDF4FF', color: '#1677FF', label: 'DOC' };

/** Badge by stored content type, never by name; anything else is shown as a document. */
const FILE_BADGES: Record<string, FileBadge> = {
  'application/json': { background: '#FFFAE9', color: '#D48200', label: 'JSON' },
  [MimeType.PDF]: { background: '#FFF2F3', color: '#F04452', label: 'PDF' },
  'text/markdown': { background: '#EDF4FF', color: '#1677FF', label: 'MD' },
  'text/plain': { background: '#EDF4FF', color: '#1677FF', label: 'TXT' },
};

export const SKILL_FOLDER_ICON_STYLE: React.CSSProperties = { color: '#B58225', flexShrink: 0 };

export const SkillFileIcon = React.memo(function SkillFileIcon({
  contentType,
  size = 28,
}: {
  contentType: string;
  size?: number;
}) {
  const mediaType = contentType.split(';')[0]?.trim().toLowerCase() ?? '';
  const { background, color, label } = FILE_BADGES[mediaType] ?? DOCUMENT_BADGE;
  return (
    <span
      aria-hidden="true"
      style={{
        alignItems: 'center',
        background,
        borderRadius: 6,
        color,
        display: 'inline-flex',
        flexShrink: 0,
        fontSize: size < 28 ? 8 : 10,
        fontWeight: 700,
        height: size,
        justifyContent: 'center',
        width: size,
      }}
    >
      {label}
    </span>
  );
});

/** A folder icon for a folder, otherwise the file's badge. */
export const SkillTreeItemIcon = React.memo(function SkillTreeItemIcon({
  contentType,
  isFolder,
  size,
}: {
  contentType: string;
  isFolder: boolean;
  size: number;
}) {
  if (isFolder) return <FolderOpen size={size} style={SKILL_FOLDER_ICON_STYLE} />;
  return <SkillFileIcon contentType={contentType} size={size} />;
});
